module.exports = __webpack_public_path__ + "static/img/5.d031d79.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/management/5.png
// module id = ZDQA
// module chunks = 7